import { Injectable } from '@angular/core';
import * as jwt_decode from 'jwt-decode';

interface TokenPayload {
  aud: string;
  iat: number;
  exp: number;
  role?: string[];
}

@Injectable({
  providedIn: 'root',
})
export class WebSocketTokenValidatorService {
  validateToken(url: string): {
    isValid: boolean;
    error?: string;
    details?: any;
  } {
    // Extract token from URL
    const tokenMatch = url.match(/access_token=([^&]+)/);
    if (!tokenMatch) {
      return {
        isValid: false,
        error: 'No access token found in URL',
      };
    }

    const token = tokenMatch[1];

    try {
      // Decode token
      const decoded = jwt_decode.jwtDecode(token);

      // Check expiration
      const currentTime = Math.floor(Date.now() / 1000);
      if (decoded.exp < currentTime) {
        return {
          isValid: false,
          error: 'Token has expired',
          details: decoded,
        };
      }

      // Validate audience (optional)
      if (!decoded.aud.includes('cyclopsrealtime.webpubsub.azure.com')) {
        return {
          isValid: false,
          error: 'Invalid token audience',
          details: decoded,
        };
      }

      return {
        isValid: true,
        details: decoded,
      };
    } catch (error) {
      return {
        isValid: false,
        error: 'Invalid token format',
      };
    }
  }
}
